<template>
  <standard-layout header="Produktverfügbarkeit prüfen">
    <template v-slot:main>
      <div class="mb-2 d-flex">
        <select v-model="selectedProduct"
                class="form-control">
          <option v-for="p in allProducts" :key="p.id" :value="p.id">{{ p.name }}</option>
        </select>
        <button class="btn btn-primary ml-2"
                @click="search">
          Suchen
        </button>
      </div>
      <div class="list-group" v-if="dates.length > 0">
        <div class="list-group-item"
             v-for="date in dates"
             :key="new Date(date.date).toDateString()">
          <span class="small text-muted">{{ date.date | date}}</span><br/>
        </div>
      </div>
      <div v-else>
        <span class="text-muted">Keine Verfügbarkeit gefunden.</span>
      </div>
    </template>
  </standard-layout>
</template>

<script>
import StandardLayout from "@/layouts/StandardLayout";
import {DateTime} from "luxon";

export default {
  computed: {
    DateTime() {
      return DateTime
    }
  },
  components: {StandardLayout},
  data() {
    return {
      allProducts: [],
      selectedProduct: null,
      dates: []
    }
  },
  methods: {
    loadAllProducts() {
      this.$api.get('/products', {params: {category: 'RES'}})
          .then(res => this.allProducts = res.data)
          .catch(err => this.handleError(err))
    },
    search() {
      this.$api.get('/availabilities', {params: {product: this.selectedProduct, channel: 'WEB'}})
          .then(res => this.dates = res.data)
          .catch(err => this.handleError(err))
    }
  },
  mounted() {
    this.loadAllProducts()
  }
}
</script>
